import React from 'react';
import './Card.css';

const Cards = (props) => {
  return (
    <div className='card_div'>
      <div className='card'>
        <div className='card-corner tl'></div>
        <div className='card-corner tr'></div>
        <div className='card-corner bl'></div>
        <div className='card-corner br'></div>
        <div className='card-shine'></div>
        <img className='card-image' src={props.image} alt="" />
        <h5 className='card-text'>{props.title}</h5>
      </div>
    </div>
  );
};

export default Cards;